import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
// Lazy load below-the-fold components
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const PackComparison = lazy(() => import('./components/PackComparison').then(m => ({
  default: m.PackComparison
})));
const MoreTestimonials = lazy(() => import('./components/MoreTestimonials').then(m => ({
  default: m.MoreTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostOfInaction = lazy(() => import('./components/CostOfInaction').then(m => ({
  default: m.CostOfInaction
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '1300381271931772';
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      const n = window.fbq = function () {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      // @ts-ignore
      n.push = n;
      // @ts-ignore
      n.loaded = !0;
      // @ts-ignore
      n.version = '2.0';
      // @ts-ignore
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-surface-white font-body selection:bg-gold/30" data-id="element-0">
      <Hero data-id="element-1" />
      <Suspense fallback={<div className="h-20" data-id="element-3" />} data-id="element-2">
        <Testimonials data-id="element-4" />
      </Suspense>
      <StatsBar data-id="element-5" />
      <PainPoints data-id="element-6" />
      <ProductOverview data-id="element-7" />
      <Suspense fallback={<div className="h-20" data-id="element-9" />} data-id="element-8">
        <Bonuses data-id="element-10" />
      </Suspense>
      <CountdownTimer data-id="element-11" />
      <PricingCards data-id="element-12" />
      <Suspense fallback={<div className="h-20" data-id="element-14" />} data-id="element-13">
        <PackComparison data-id="element-15" />
        <MoreTestimonials data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <CostOfInaction data-id="element-19" />
        <FinalCTA data-id="element-20" />
        <Footer data-id="element-21" />
      </Suspense>
    </div>;
}